import { LoadMoreFn } from "react-relay";
import { OperationType } from "relay-runtime";
import { FormattedMessage } from "react-intl";
import { Button } from "@/kit/ui/button";

interface Props<T extends OperationType> {
  loadMore: LoadMoreFn<T>;
  count?: number;
  onComplete?: ((arg: Error | null) => void) | undefined;
  hasMore: boolean;
  isLoading: boolean;
  children?: React.ReactNode;
  className?: string;
}

export default function LoadMore<T extends OperationType>({
  loadMore,
  count = 10,
  onComplete,
  hasMore,
  isLoading,
  children,
  className,
}: Props<T>) {
  if (!hasMore) {
    return null;
  }
  return (
    <Button
      variant="secondary"
      disabled={isLoading}
      onClick={() => loadMore(count, { onComplete })}
      className={className}
    >
      {children || <FormattedMessage defaultMessage="Show more" />}
    </Button>
  );
}
